export default __webpack_public_path__ + "7a1474afda6a3d5466577f1b6c7e92ab.png";